/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_MyHoldingsOverviewDto_MyHoldingsOverviewDto } from '../models/Wealthlane_AwardService_Dtos_MyHoldingsOverviewDto_MyHoldingsOverviewDto';
import type { Wealthlane_AwardService_EsppAwards_EsppParticipant } from '../models/Wealthlane_AwardService_EsppAwards_EsppParticipant';
import type { Wealthlane_AwardService_EsppAwards_EsppPurchaseEntities_EsppPurchaseItem } from '../models/Wealthlane_AwardService_EsppAwards_EsppPurchaseEntities_EsppPurchaseItem';
import type { Wealthlane_AwardService_OptionAwards_OptionAwards } from '../models/Wealthlane_AwardService_OptionAwards_OptionAwards';
import type { Wealthlane_AwardService_OptionExercise_OptionExercise } from '../models/Wealthlane_AwardService_OptionExercise_OptionExercise';
import type { Wealthlane_AwardService_ParticipantTermination_ParticipantTermination } from '../models/Wealthlane_AwardService_ParticipantTermination_ParticipantTermination';
import type { Wealthlane_AwardService_PSUAward_PSUAward } from '../models/Wealthlane_AwardService_PSUAward_PSUAward';
import type { Wealthlane_AwardService_RSUAward_RSUAward } from '../models/Wealthlane_AwardService_RSUAward_RSUAward';
import type { Wealthlane_AwardService_TADRSInstruction_TADRSInstruction } from '../models/Wealthlane_AwardService_TADRSInstruction_TADRSInstruction';
import type { Wealthlane_AwardService_TaxInput_TaxInput } from '../models/Wealthlane_AwardService_TaxInput_TaxInput';
import type { Wealthlane_AwardService_TradePreClearanceRequest_TradePreClearanceRequest } from '../models/Wealthlane_AwardService_TradePreClearanceRequest_TradePreClearanceRequest';
import type { Wealthlane_AwardService_Transaction_Transaction } from '../models/Wealthlane_AwardService_Transaction_Transaction';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MyHoldingsOverviewSharedService {
  /**
   * @returns Wealthlane_AwardService_Dtos_MyHoldingsOverviewDto_MyHoldingsOverviewDto OK
   * @throws ApiError
   */
  public static getApiAwardApiAppMyHoldingsOverviewHoldings(): CancelablePromise<Wealthlane_AwardService_Dtos_MyHoldingsOverviewDto_MyHoldingsOverviewDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/award/api/app/my-holdings-overview/holdings',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param firstName
   * @param lastName
   * @param employeeId
   * @param email
   * @param id
   * @param tenantId
   * @param companyId
   * @param payrollId
   * @param middleName
   * @param dateOfBirth
   * @param gender
   * @param maritalStatus
   * @param countryOfLegalResidency
   * @param addressLine1
   * @param participantApprovalStatus
   * @param statusName
   * @param creatorId
   * @param creationDateTime
   * @param hireDate
   * @param abpUserId
   * @param isOnBoarded
   * @param jobTitle
   * @param department
   * @param employeeStatus
   * @param isTaxCertificationVerified
   * @param employeeType
   * @param costCentre
   * @param isTradePreClearanced
   * @param isBlackout
   * @param homeStateAbbreviation
   * @param workStateAbbreviation
   * @param accountId
   * @param isEmailSend
   * @param isSection16
   * @param isRule144
   * @param fullName
   * @param terminationRuleSetId
   * @param settlementTypeId
   * @param rsuAwards
   * @param optionAwards
   * @param psuAwards
   * @param tradePreClearanceRequests
   * @param optionExercises
   * @param pspParticipantId
   * @param esppPurchaseItems
   * @param participantTerminations
   * @param taxInputs
   * @param esppParticipants
   * @param transactions
   * @param tadrsInstructions
   * @param terminationRuleSetId
   * @param terminationRuleSetTenantId
   * @param terminationRuleSetExtraProperties
   * @param terminationRuleSetConcurrencyStamp
   * @param settlementTypeId
   * @param settlementTypeSystemName
   * @param settlementTypeDisplayName
   * @param settlementTypeIsCashSellType
   * @param settlementTypeExtraProperties
   * @param settlementTypeConcurrencyStamp
   * @param extraProperties
   * @param concurrencyStamp
   * @param isForParticipant
   * @returns Wealthlane_AwardService_Dtos_MyHoldingsOverviewDto_MyHoldingsOverviewDto OK
   * @throws ApiError
   */
  public static getApiAwardApiAppMyHoldingsOverviewSharedPortfolioHoldings(
    firstName: string,
    lastName: string,
    employeeId: string,
    email: string,
    id?: string,
    tenantId?: string,
    companyId?: string,
    payrollId?: string,
    middleName?: string,
    dateOfBirth?: string,
    gender?: string,
    maritalStatus?: string,
    countryOfLegalResidency?: string,
    addressLine1?: string,
    participantApprovalStatus?: number,
    statusName?: string,
    creatorId?: string,
    creationDateTime?: string,
    hireDate?: string,
    abpUserId?: string,
    isOnBoarded?: boolean,
    jobTitle?: string,
    department?: string,
    employeeStatus?: string,
    isTaxCertificationVerified?: boolean,
    employeeType?: string,
    costCentre?: string,
    isTradePreClearanced?: boolean,
    isBlackout?: boolean,
    homeStateAbbreviation?: string,
    workStateAbbreviation?: string,
    accountId?: string,
    isEmailSend?: boolean,
    isSection16?: boolean,
    isRule144?: boolean,
    fullName?: string,
    terminationRuleSetId?: string,
    settlementTypeId?: string,
    rsuAwards?: Array<Wealthlane_AwardService_RSUAward_RSUAward>,
    optionAwards?: Array<Wealthlane_AwardService_OptionAwards_OptionAwards>,
    psuAwards?: Array<Wealthlane_AwardService_PSUAward_PSUAward>,
    tradePreClearanceRequests?: Array<Wealthlane_AwardService_TradePreClearanceRequest_TradePreClearanceRequest>,
    optionExercises?: Array<Wealthlane_AwardService_OptionExercise_OptionExercise>,
    pspParticipantId?: string,
    esppPurchaseItems?: Array<Wealthlane_AwardService_EsppAwards_EsppPurchaseEntities_EsppPurchaseItem>,
    participantTerminations?: Array<Wealthlane_AwardService_ParticipantTermination_ParticipantTermination>,
    taxInputs?: Array<Wealthlane_AwardService_TaxInput_TaxInput>,
    esppParticipants?: Array<Wealthlane_AwardService_EsppAwards_EsppParticipant>,
    transactions?: Array<Wealthlane_AwardService_Transaction_Transaction>,
    tadrsInstructions?: Array<Wealthlane_AwardService_TADRSInstruction_TADRSInstruction>,
    terminationRuleSetTenantId?: string,
    terminationRuleSetExtraProperties?: Record<string, any>,
    terminationRuleSetConcurrencyStamp?: string,
    settlementTypeSystemName?: string,
    settlementTypeDisplayName?: string,
    settlementTypeIsCashSellType?: boolean,
    settlementTypeExtraProperties?: Record<string, any>,
    settlementTypeConcurrencyStamp?: string,
    extraProperties?: Record<string, any>,
    concurrencyStamp?: string,
    isForParticipant?: boolean
  ): CancelablePromise<Wealthlane_AwardService_Dtos_MyHoldingsOverviewDto_MyHoldingsOverviewDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/award/api/app/my-holdings-overview-shared/portfolio-holdings',
      query: {
        Id: id,
        TenantId: tenantId,
        CompanyId: companyId,
        PayrollId: payrollId,
        FirstName: firstName,
        MiddleName: middleName,
        LastName: lastName,
        EmployeeId: employeeId,
        Email: email,
        DateOfBirth: dateOfBirth,
        Gender: gender,
        MaritalStatus: maritalStatus,
        CountryOfLegalResidency: countryOfLegalResidency,
        AddressLine1: addressLine1,
        ParticipantApprovalStatus: participantApprovalStatus,
        StatusName: statusName,
        CreatorId: creatorId,
        CreationDateTime: creationDateTime,
        HireDate: hireDate,
        AbpUserId: abpUserId,
        IsOnBoarded: isOnBoarded,
        JobTitle: jobTitle,
        Department: department,
        EmployeeStatus: employeeStatus,
        IsTaxCertificationVerified: isTaxCertificationVerified,
        EmployeeType: employeeType,
        CostCentre: costCentre,
        isTradePreClearanced: isTradePreClearanced,
        IsBlackout: isBlackout,
        HomeStateAbbreviation: homeStateAbbreviation,
        WorkStateAbbreviation: workStateAbbreviation,
        AccountId: accountId,
        IsEmailSend: isEmailSend,
        IsSection16: isSection16,
        IsRule144: isRule144,
        FullName: fullName,
        TerminationRuleSetId: terminationRuleSetId,
        SettlementTypeId: settlementTypeId,
        RSUAwards: rsuAwards,
        OptionAwards: optionAwards,
        PSUAwards: psuAwards,
        TradePreClearanceRequests: tradePreClearanceRequests,
        OptionExercises: optionExercises,
        PspParticipantId: pspParticipantId,
        EsppPurchaseItems: esppPurchaseItems,
        ParticipantTerminations: participantTerminations,
        TaxInputs: taxInputs,
        EsppParticipants: esppParticipants,
        Transactions: transactions,
        TADRSInstructions: tadrsInstructions,
        'TerminationRuleSet.Id': terminationRuleSetId,
        'TerminationRuleSet.TenantId': terminationRuleSetTenantId,
        'TerminationRuleSet.ExtraProperties': terminationRuleSetExtraProperties,
        'TerminationRuleSet.ConcurrencyStamp': terminationRuleSetConcurrencyStamp,
        'SettlementType.Id': settlementTypeId,
        'SettlementType.SystemName': settlementTypeSystemName,
        'SettlementType.DisplayName': settlementTypeDisplayName,
        'SettlementType.IsCashSellType': settlementTypeIsCashSellType,
        'SettlementType.ExtraProperties': settlementTypeExtraProperties,
        'SettlementType.ConcurrencyStamp': settlementTypeConcurrencyStamp,
        ExtraProperties: extraProperties,
        ConcurrencyStamp: concurrencyStamp,
        isForParticipant: isForParticipant,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }
}
